<template>
  <div class="box-container">
    <div class="box-nested-container">
      <div class='box' :class="right?'right':'left'">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BGAnimation',
  props: {
    right: {
      type: Boolean,
      default: false
    },
  }
}
</script>

<style lang="scss" scoped>
.box-container {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  > .box-nested-container {
    height: 100%;
    width: 100%;
    overflow: hidden;
    position: relative;
    > .box {
      position: absolute;
      top: 0;
      transform: rotate(80deg);
      &.right {
        right: 0;
        > div {
          margin-top: -950px;
        }
      } 
      &.left {
        left: 0;
        > div {
          margin-top: -250px;
        }
      }
      > div {
        opacity: .4;
        position: absolute;
        top: 3%;
        left: 10%;
        background: rgb($primary,1);
        width: 1500px;
        height: 1300px;
        margin-left: -150px;
        transform-origin: 50% 48%;
        border-radius: 43%;
        animation: drift 7000ms infinite linear;
        &:nth-child(2) {
          animation: drift 3000ms infinite linear;
          opacity: .1;
          background: rgb($primary,0.5);
        }
        &:nth-child(3) {
          animation: drift 7500ms infinite linear;
          background: rgb($primary,0.25);
        }
      }
      &:after {
        content: '';
        display: block;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 11;
        transform: translate3d(0, 0, 0);
      }
    }
  }
}

@keyframes drift {
  from { 
    transform: rotate(0deg); 
  }
  from { 
    transform: rotate(360deg); 
  }
}
</style>